import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

const disabledState = '&[disabled]'
const activeState = '&[data-active]'
const hoverState = '&:not([disabled]):hover, &:not([disabled])[data-hover]'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.overlayers.option', {
      wrapper: {
        bg: 'white',
        overflow: 'auto',
        boxShadow: 'level2',
        borderRadius: 'control',
        py: 8,
        zIndex: 600,
        maxHeight: 280,
      },
      simple: {
        bg: 'white',
        color: 'body',
        py: 9,
        px: 12,
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        [activeState]: {
          color: 'brand',
        },
        [disabledState]: {
          cursor: 'not-allowed',
          color: 'palette.body.disable',
        },
        [hoverState]: {
          bg: 'palette.tinBlue.base',
          color: 'palette.brand.hover',
        },
      },
      colorSvg: {
        svg: {
          fill: 'mute',
        },
        [activeState]: {
          svg: {
            fill: 'brand',
          },
        },
        [disabledState]: {
          svg: {
            fill: 'palette.body.disable',
          },
        },
        [hoverState]: {
          svg: {
            fill: 'palette.brand.hover',
          },
        },
      },
      content: {
        flex: 1,
        wordBreak: 'break-all',
      },
    }),
  ]
}
